export type TNativeAudioBufferSourceNode = AudioBufferSourceNode;
